import { Button, Grid, InputBase, Typography } from '@material-ui/core';
import Clear from '@material-ui/icons/Clear';
import React from 'react';
import { IKeypadInputFieldProps } from '../../interfaces/IKeypadInputFieldProps';
import { keypadInputFieldStyles } from './keypad-input-field-styles';

const KeypadInputField: React.FC<IKeypadInputFieldProps> = (
  props: IKeypadInputFieldProps,
): JSX.Element => {
  const classes = keypadInputFieldStyles();
  const handleOnKeyPress = (
    event: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>,
  ): void => {
    if (event.keyCode === 46) {
      event.preventDefault();
    }

    if (event.keyCode === 13) {
      event.preventDefault();
      props.onSubmit();
    }
  };

  const inputStyle = (isPriceMode?: boolean): JSX.Element => {
    if (isPriceMode) {
      return (
        <Grid container>
          <Grid item>
            <InputBase
              value={props.itemCode}
              inputRef={props.inputRef}
              style={{ fontSize: '2.6vh', paddingTop: '0.8em' }}
              classes={{ input: classes.priceModeInput }}
              inputProps={{
                name: 'keypad-input',
                autoComplete: 'off',
                'data-keyboard-owner': `${props.keyboardId}-focus`,
                'data-testid': props.dataTestId,
              }}
              onChange={props.onChange}
              onKeyDown={handleOnKeyPress}
            />
          </Grid>
        </Grid>
      );
    } else {
      return (
        <Grid container direction='row' className={`fullHeight`}>
          <Grid item xs={9}>
            <Grid
              container
              className={`${classes.helperText} fullHeight`}
              data-testid='helper-text'
            >
              <Grid
                item
                className={
                  props.truncateInputFieldLabel ? classes.truncateInputFieldLabel : undefined
                }
              >
                <Typography variant='body2' className={`${classes.keypadAdjustOverflow}`} noWrap>
                  {props.inputFieldLabel}
                </Typography>
              </Grid>
              <Grid container item xs={12}>
                <InputBase
                  inputRef={props.inputRef}
                  autoFocus={props.autoFocus}
                  value={props.itemCode}
                  classes={{ input: classes.input }}
                  inputProps={{
                    name: 'keypad-input',
                    autoComplete: 'off',
                    'data-keyboard-owner': `${props.keyboardId}-focus`,
                    'data-testid': props.dataTestId,
                  }}
                  onChange={props.onChange}
                  onKeyDown={handleOnKeyPress}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={3} className={classes.clearInputButtonContainer}>
            <Grid container justifyContent='center'>
              <Grid item>
                <Button
                  onClick={(): void => props.resetKeypad()}
                  data-testid='keypad-clear'
                  disableRipple={true}
                  className={classes.clearButton}
                >
                  <Clear />
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    }
  };

  return (
    <Grid item className={`fullWidth`}>
      <Grid container direction='column' alignItems='center' className={`fullWidth`}>
        <Grid item className={`${classes.inputContainer}`}>
          {inputStyle(props.isPriceMode)}
        </Grid>
        <Grid item className={`fullWidth`}>
          <Grid container justifyContent='flex-start'>
            <Grid item>
              <Typography
                variant='body2'
                className={`${classes.keypadAdjustOverflow} ${classes.caption}`}
              >
                {props.inputInstructionsLabel}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default KeypadInputField;
